module.exports = __webpack_public_path__ + "img/slide-3.18859029.png";